import { useTranslation } from "react-i18next";
import { MainLogoNew } from "../../mainLogoNew";

const DmeTechInfo: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-cover bg-center flex flex-col
        md:bg-[linear-gradient(to_top,rgba(2,8,19,1),rgba(0,0,0,0)),url('/img/serjan-midili.jpg')]"
      >
        <div className="place-self-center max-w-screen-2xl w-full md:my-12 md:mb-28 flex justify-center flex-row">
          <div className="md:w-1/3 max-md:w-full">
            <MainLogoNew onclickUrl="/" mode="dark" w={160} h={70} />

            <h1 className="text-5xl font-bold pb-8 max-md:p-8 text-primary">
              {t("Smart solutions &")}{" "}
              <span className="text-white">
                {t("Custom services for professionals")}
              </span>
            </h1>
            <h2 className="text-textsecondary text-lg max-md:p-8">
              {t("Our mission is to inspire BMW enthusiasts around the world")}
            </h2>
          </div>
          <div className="md:w-2/3 max-md:hidden"></div>
        </div>

        <div className="overflow-hidden md:hidden">
          <img
            className="transform scale-150 h-auto max-w-full"
            src="/img/serjan-midili.jpg"
            alt=""
          />
        </div>
      </div>
    </>
  );
};

export default DmeTechInfo;
